import React from 'react';
import Grid from '@material-ui/core/Grid';
import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  colorBox: {
    width: '42px',
    height: '100%'
  },
  title: {
    marginLeft: '1rem',
    fontSize: theme.typography.h6.fontSize
  },
  headerContainer: {
    height: '49px',
    backgroundColor: '#E5E5E5',
    paddingRight: '1rem',
    marginBottom: '0.3rem'
  },
  mainBox: {
    display: 'flex',
    alignItems: 'center',
    height: '100%'
  }
}));

interface TableHeaderProps {
  children?: any;
  title: string;
  color: string;
}

const TableHeader = ({ children, title, color }: TableHeaderProps) => {
  const classes = useStyles();
  return (
    <Grid
      container
      className={classes.headerContainer}
      justifyContent="space-between"
      alignItems="center"
    >
      <Grid item className={classes.mainBox}>
        <Grid
          item
          style={{ backgroundColor: color }}
          className={classes.colorBox}
        ></Grid>
        <Grid item className={classes.title}>
          {title}
        </Grid>
      </Grid>
      <Grid item>{children}</Grid>
    </Grid>
  );
};

export default TableHeader;
